var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
module.exports = x({ ["fetch"]: () => (__WEBPACK_EXTERNAL_MODULE_utils__.fetch), ["parseErrors"]: () => (__WEBPACK_EXTERNAL_MODULE_utils__.parseErrors) });